import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Select } from "antd";
import Input from "Components/UI/Input";
import PropTypes from "prop-types";
import { useGetProjectsQuery } from "AppQuries/project/project";
import { useGetAllShiftPoliciesQuery } from "AppQuries/shift/policy/shift-policy";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { useGetAllUserMasterQuery } from "AppQuries/user/user-master";
import { useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import dayjs from "dayjs";

const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];
const priorityOptions = [
  { label: "Low", value: "Low" },
  { label: "Medium", value: "Medium" },
  { label: "High", value: "High" },
];

const statusOptions = [
  { label: "Open", value: "Open" },
  { label: "Hold", value: "Hold" },
  { label: "Reopen", value: "Reopen" },
  { label: "Closed", value: "Closed" },
];
const JobForm = ({ mode = "A" }) => {
  const {
    control,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();

  const { data: userMaster } = useGetAllUserMasterQuery({
    companyCode: watch("companyCode"),
    locationCode: watch("locationCode"),
  });

  const { data: projects } = useGetProjectsQuery({
    companyCode: watch("companyCode"),
    locationCode: watch("locationCode"),
    isTrue: true,
  });

  const { data: shift } = useGetAllShiftPoliciesQuery({
    companyCode: watch("companyCode"),
    locationCode: watch("locationCode"),
    isTrue: true,
  });

  const assignedByOptions = Array.isArray(userMaster)
    ? userMaster
        // ?.filter((r) => r.isActive === true)
        .map((r) => ({ label: r.userName, value: r.userName }))
    : [];

  const projectsOptions = Array.isArray(projects)
    ? projects
        // ?.filter((r) => r.isActive === true)
        .map((r) => ({ label: r.projectName, value: r.projectCode }))
    : [];

  const shiftOptions = Array.isArray(shift)
    ? shift
        // ?.filter((r) => r.isActive === true)
        .map((r) => ({ label: r.shiftName, value: r.shiftPolicyID.toString() }))
    : [];

  const employeeOptions = useFormattedEmployees({
    companyCode: watch("companyCode"),
    locationCode: watch("locationCode"),
  });

  return (
    <div className="form-row row">
      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="jobCode"
          type="text"
          placeholder="Job Code"
          className={`form-control ${errors.jobCode ? "is-invalid" : ""}`}
          label="Job Code"
          labelClassName="form-label"
          required={true}
          requiredMessage="Job Code is required"
          readOnly={mode === "E"}
        />
      </div> */}

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="jobTitle"
          type="text"
          placeholder="Job Title"
          className={`form-control ${errors.jobTitle ? "is-invalid" : ""}`}
          label="Job Title"
          labelClassName="form-label"
          required={true}
          requiredMessage="Job Title is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="remarks"
          type="text"
          placeholder="Description"
          className={`form-control ${errors.remarks ? "is-invalid" : ""}`}
          label="Description"
          labelClassName="form-label"
          required={true}
          requiredMessage="Description is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="projectCode"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.projectCode ? "form-control is-invalid" : ""
          }`}
          label="Project"
          labelClassName="form-label"
          optionData={projectsOptions}
          required={true}
          // labelInValue
          requiredMessage="Project is required"
          onChange={(e) => {
            setValue("projectCode", e);
          }}
          defaultValue={watch("projectCode")}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3 ">
        <div className="form-floating">
          <Controller
            name="selectedEmployees"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Select
                mode="multiple"
                placeholder="Select employees"
                className={`form-control ${
                  errors.selectedEmployees ? "is-invalid" : ""
                }`}
                options={employeeOptions}
                value={value}
                onChange={(selectedOptions) => {
                  onChange(selectedOptions); // updates react-hook-form
                  setValue("selectedEmployees", selectedOptions);
                  trigger("selectedEmployees");
                }}
                style={{ width: "100%", height: "auto" }}
              />
            )}
          />

          <label className="form-label">
            <span className="form-label">Employees</span>
          </label>
          {errors.selectedEmployees && (
            <div className="invalid-feedback">
              {errors.selectedEmployees?.message || "Invalid input"}
            </div>
          )}
        </div>
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="jobStartDate"
          type="date"
          placeholder="Job Start Date"
          className={`form-control ${errors.jobStartDate ? "is-invalid" : ""}`}
          label="Job Start Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="Job Start Date is required"
          defaultValue=""
          dateFormat="YYYY-MM-DD"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="jobEndDate"
          type="date"
          placeholder="Job End Date"
          className={`form-control ${errors.jobEndDate ? "is-invalid" : ""}`}
          label="Job End Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="Job End Date is required"
          defaultValue=""
          dateFormat="YYYY-MM-DD"
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="jobStartTime"
          type="timePicker"
          format="HH:mm"
          placeholder="Task Start Time"
          className={`form-control ${errors.jobStartTime ? "is-invalid" : ""}`}
          label="Task Start Time"
          labelClassName="form-label"
          required={true}
          requiredMessage="Task Start is required"
          onChange={(time, timeString) => {
            setValue("jobStartTime", timeString);
            trigger("jobStartTime");
          }}
          value={
            watch("jobStartTime") ? dayjs(watch("jobStartTime"), "HH:mm") : null
          }
          variant="borderless"
          allowClear={false}
          style={{ width: "100%" }}
        />
      </div>

      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="jobStartTime"
          type="time"
          placeholder="Task Start Time"
          className={`form-control ${errors.jobStartTime ? "is-invalid" : ""}`}
          label="Task Start Time"
          labelClassName="form-label"
          required={true}
          requiredMessage="Task Start Time is required"
          defaultValue=""
        />
      </div> */}

      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="jobEndTime"
          type="timePicker"
          placeholder="Task End Time"
          className={`form-control ${errors.jobEndTime ? "is-invalid" : ""}`}
          label="Task End Time"
          labelClassName="form-label"
          required={true}
          requiredMessage="Task End Time is required"
          defaultValue=""
          // value={
          //   watch("jobEndTime")
          //     ? dayjs(watch("jobEndTime"), "HH:mm")
          //     : null
          // }
          format="HH:mm"
           variant="borderless"
          allowClear={false}
          style={{ width: "100%" }}
        />
      </div> */}
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="jobEndTime"
          type="timePicker"
          format="HH:mm"
          placeholder="Shift Login Grace Time"
          className={`form-control ${errors.jobEndTime ? "is-invalid" : ""}`}
          label="Task End Time"
          labelClassName="form-label"
          required={true}
          requiredMessage="Task End Time is required"
          onChange={(time, timeString) => {
            setValue("jobEndTime", timeString);
            trigger("jobEndTime");
          }}
          value={
            watch("jobEndTime") ? dayjs(watch("jobEndTime"), "HH:mm") : null
          }
          variant="borderless"
          allowClear={false}
          style={{ width: "100%" }}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="shiftCode"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.shiftCode ? "form-control is-invalid" : ""
          }`}
          label="Shift"
          labelClassName="form-label"
          optionData={shiftOptions}
          required={true}
          requiredMessage="Shift is required"
          onChange={(e) => {
            setValue("shiftCode", e);
            trigger("shiftCode");
          }}
          defaultValue={watch("shiftCode")}
        />
      </div>

      <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
        <Input
          name="assignedBy"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.assignedBy ? "is-invalid" : ""
          }`}
          label="Assigned By"
          labelClassName="form-label"
          optionData={assignedByOptions}
          required={false}
          requiredMessage="Assigned By is required"
          onChange={(selectedOption) => {
            setValue("assignedBy", selectedOption ? selectedOption : null);
            trigger("assignedBy");
          }}
          defaultValue={watch("assignedBy")}
        />
      </div>

      <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
        <Input
          name="priority"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.priority ? "is-invalid" : ""
          }`}
          label="Priority"
          labelClassName="form-label"
          optionData={priorityOptions}
          required={false}
          requiredMessage="Priority is required"
          onChange={(selectedOption) => {
            setValue("priority", selectedOption);
            trigger("priority");
          }}
          defaultValue={watch("priority")}
        />
      </div>

      <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
        <Input
          name="jobStatus"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.jobStatus ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={statusOptions}
          required={false}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("jobStatus", selectedOption);
            trigger("jobStatus");
          }}
          defaultValue={watch("status")}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder=""
          className={`form-control  select ${
            errors.isActive ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>
    </div>
  );
};

JobForm.propTypes = {
  mode: PropTypes.string.isRequired,
};
export default JobForm;
